// ** Redux Imports
import {combineReducers} from 'redux';

// ** Reducers Imports
import auth from './auth';
import navbar from './navbar';
import layout from './layout';
import chat from '@src/views/apps/chat/store/reducer';
import todo from '@src/views/apps/todo/store/reducer';
import users from '@src/views/apps/user/store/reducer';
import email from '@src/views/apps/email/store/reducer';
import invoice from '@src/views/apps/invoice/store/reducer';
import calendar from '@src/views/apps/calendar/store/reducer';
import ecommerce from '@src/views/apps/ecommerce/store/reducer';
import dataTables from '@src/views/tables/data-tables/store/reducer';
import isps from '@src/views/apps/isp/store/reducer';
import usersISP from '@src/views/apps/user-pl/store/reducer';
import usersOnce from '@src/views/apps/user-fb/store/reducer';
import plans from '@src/views/apps/plan/store/reducer';
import reporte from '@src/views/apps/reporte/store/reducer';
import prospectos from '@src/views/apps/prospects/store/reducer';
import myprospects from '@src/views/apps/my-prospects/store/reducer';
import noInteresados from '../../views/apps/reportes/no-interesados/store/reducer';
import clientes from '../../views/apps/reportes/clientes/store/reducer';
import masnet from '../../views/apps/mis-clientes/masnet/store/reducer';
import fibralink from '../../views/apps/mis-clientes/fibralink/store/reducer';
import masnetVentas from '@src/views/apps/mis-ventas/masnet/store/reducer';
import fibralinkVentas from '@src/views/apps/mis-ventas/fibralink/store/reducer';
const rootReducer = combineReducers({
  auth,
  todo,
  chat,
  email,
  users,
  navbar,
  layout,
  invoice,
  calendar,
  ecommerce,
  dataTables,
  plans,
  isps,
  usersISP,
  usersOnce,
  reporte,
  prospectos,
  myprospects,
  noInteresados,
  clientes,
  masnet,
  fibralink,
  masnetVentas,
  fibralinkVentas,
});

export default rootReducer;
